export default __webpack_public_path__ + "static/media/Circle-close-button.bc38cc9f.svg";